import { render } from "./BrandsPage.vue?vue&type=template&id=0f9ef517&lang=pug"
import script from "./BrandsPage.vue?vue&type=script&lang=js"
export * from "./BrandsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__